<template>
  <article>
    <job-preview-content-outline
      title="選考プロセス"
      :comment-highlights="getCommentHighlights(targetIdMap.selection.process)"
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      :text-counts="[getTextCount('選考プロセス', selection.selectionProcess, targetIdMap.selection.process)]"
      :target-id="targetIdMap.selection.process"
      :value="selection.selectionProcess"
      data-test="process"
      v-on="$listeners"
    />

    <template v-for="index in [1,2,3]">
      <job-preview-content-interview
        v-if="isShow.interview(index)"
        :key="`interview-${index}`"
        :index="index"
        :zip="selection[`zipCode${index}`]"
        :address="selection[`address${index}`]"
        :person="selection[`personInCharge${index}`]"
        :tel="selection[`tel${index}`]"
        :map="selection[`placeMapAddress${index}`]"
        :comment-highlights="getAnyCommentHighlights(targetIdMap.selection.interview.prefix,index)"
        :highlight-mode="highlightMode"
        :text-count-mode="textCountMode"
        :data-test="`interview-${index}`"
        v-on="$listeners"
      />
    </template>

    <job-preview-content-inquiry
      :company-name="companyName"
      :url="selection.inquiryUrl"
      :zip="selection.inquiryZip"
      :address="selection.inquiryAddress"
      :person="selection.inquiryPerson"
      :tel="selection.inquiryTel"
      :email="selection.inquiryEmail"
      :comment-highlights="getAnyCommentHighlights(targetIdMap.selection.inquiry.prefix)"
      :highlight-mode="highlightMode"
      :text-count-mode="textCountMode"
      data-test="inquiry"
      v-on="$listeners"
    />

    <job-preview-content-outline
      v-if="isShow.links"
      title="関連リンク"
      data-test="links"
      v-on="$listeners"
    >
      <job-preview-content
        :comment-highlights="getAnyCommentHighlights(targetIdMap.selection.link)"
        :highlight-mode="highlightMode"
        data-test="links-content"
        v-on="$listeners"
      >
        <template #body>
          <p class="clearfix">
            <template v-for="index in [1,2,3]">
              <template v-if="selection[`companyLinkNm${index}`]">
                <component
                  :is="tag"
                  :id="`${targetIdMap.selection.link}-${index}`"
                  :key="`link-${index}`"
                  :href="selection[`companyLinkUrl${index}`]"
                  :class="{'text-underline':highlightMode}"
                  rel="nofollow"
                  target="_blank"
                  :data-test="`link-${index}`"
                  v-text="selection[`companyLinkNm${index}`]"
                /><br :key="`link-br-${index}`">
              </template>
            </template>
          </p>
        </template>
      </job-preview-content>
    </job-preview-content-outline>
  </article>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentOutline from '@/components/atoms/JobPreviewContentOutline'
import JobPreviewContentInterview from '@/components/atoms/JobPreviewContentInterview'
import JobPreviewContentInquiry from '@/components/atoms/JobPreviewContentInquiry'
import JobPreviewContent from '@/components/atoms/JobPreviewContent'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'
import jobPreviewUrlHighlight from '@/lib/jobPreviewUrlHighlight'

export default {
  components: {
    JobPreviewContentOutline,
    JobPreviewContentInterview,
    JobPreviewContentInquiry,
    JobPreviewContent
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight, jobPreviewUrlHighlight],
  props: {
    companyName: {
      type: String,
      default: ''
    },
    selection: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    urlHighlightTargetIds () {
      return [
        this.targetIdMap.selection.inquiry.url,
        this.targetIdMap.selection.link
      ]
    }
  }
}
</script>
